import React from 'react';

export const Divider: React.FC = () => <hr className="ctn-neutral-grey-strong my-xxs!" />;
